module.exports = __webpack_public_path__ + "img/Szentes_Laszlo_2026.9d46248a.jpg";